import React from "react";

const Commingsoon = () => {
  return (
    <div className="relative bg-white w-full h-[765px] overflow-hidden text-left text-[20px] font-inter">
      <div className="absolute top-[165px] left-[436px] rounded-[18px] bg-black w-[568px] h-[435px] overflow-hidden">
        <img
          className="absolute top-[24px] left-[98px] w-[348px] h-[309px] object-cover"
          alt=""
          src=" https://cdn.discordapp.com/attachments/1184864067295395960/1185748953837346826/Black_White_Minimal_Animated_Coming_Soon_Instagram_Post.gif?ex=6590bdc4&is=657e48c4&hm=69038dfb64195a65f85b17a1355e91b16a030233ddcc2b1f0f79061f3e8e0214&"
        />
        <b className="absolute top-[357px] left-[226px] text-white  ">
          Dsocial.dso
        </b>
      </div>
    </div>
  );
};

export default Commingsoon;
